/**
 * Módulo do componente Termo List (termo-list)
 */
(function(){
	angular
		.module('termoListModule', []);
})();